import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { Flex, Text, Img, useTooltip, FlexProps } from 'vvs-uikit'
import { formatNumber } from 'utils/formatBalance'

export const BestExpBadge = ({ value, ...props }: { value: number } & FlexProps) => {
  const { t } = useTranslation()
  const { targetRef, tooltip, tooltipVisible } = useTooltip(t('Highest Total EXP ever earned (per Mole)'), {
    placement: 'top',
    tooltipOffset: [0, 6],
  })

  return (
    <>
      <Badge px="8px" py="2px" ref={targetRef} {...props}>
        <Img src="/images/vvsGotchi/star.png" height="16px" />
        <BadgeText>
          {t('Best')} {formatNumber(value, 0, 3)}
        </BadgeText>
      </Badge>
      {tooltipVisible && tooltip}
    </>
  )
}

export const Badge = styled(Flex)`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.lightBeige};
  border-radius: 4px;
`
export const BadgeText = styled(Text)`
  color: ${({ theme }) => theme.colors.darkestNightBlue};
  margin-left: 0.25em;
  white-space: nowrap;
`
